import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropzone", "filesList", "fileInput"];

  connect() {
    this.files = [];
    this.setupEventListeners();
  }

  setupEventListeners() {
    [
      "drag",
      "dragstart",
      "dragend",
      "dragover",
      "dragenter",
      "dragleave",
      "drop",
    ].forEach((eventName) => {
      this.dropzoneTarget.addEventListener(
        eventName,
        this.preventDefaults.bind(this),
        false,
      );
      if (["dragover", "dragenter"].includes(eventName)) {
        this.dropzoneTarget.addEventListener(
          eventName,
          this.highlight.bind(this),
          false,
        );
      }
      if (["dragleave", "dragend", "drop"].includes(eventName)) {
        this.dropzoneTarget.addEventListener(
          eventName,
          this.unhighlight.bind(this),
          false,
        );
      }
    });

    this.dropzoneTarget.addEventListener(
      "drop",
      this.handleDrop.bind(this),
      false,
    );
  }

  selectFiles() {
    this.fileInputTarget.click();
  }

  preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  highlight() {
    this.dropzoneTarget.classList.add("is-dragover");
  }

  unhighlight() {
    this.dropzoneTarget.classList.remove("is-dragover");
  }

  handleDrop(e) {
    let dt = e.dataTransfer;
    let droppedFiles = dt.files;
    this.files = [...droppedFiles];
    this.handleFiles(this.files);
    this.fileInputTarget.files = dt.files;
  }

  handleFiles(files) {
    files.forEach(this.uploadFile.bind(this));
  }

  uploadFile(file) {
    let fileDiv = document.createElement("div");
    fileDiv.className = "file-upload-item";
    fileDiv.innerHTML = `
      <div class="flex items-center">
        <div class="flex flex-col gap-1">
          <span class="file-upload-item__name">${file.name}</span>
        </div>
      </div>
      <div>
        <svg class="file-upload-item__remove" data-action="click->file-upload#removeFile" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        </svg>
      </div>
    `;
    this.filesListTarget.appendChild(fileDiv);
  }

  removeFile(e) {
    let fileDiv = e.currentTarget.closest(".file-upload-item");
    let fileName = fileDiv.querySelector(".file-upload-item__name").textContent;
    let index = this.files.findIndex((f) => f.name === fileName);
    if (index !== -1) {
      this.files.splice(index, 1);
      fileDiv.remove();
    }
  }

  handleFileInputChange(e) {
    this.files = [...e.target.files];
    this.filesListTarget.innerHTML = "";
    this.files.forEach(this.uploadFile.bind(this));
  }

  humanFileSize(size) {
    var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return (
      (size / Math.pow(1024, i)).toFixed(2) * 1 +
      " " +
      ["B", "kB", "MB", "GB", "TB"][i]
    );
  }
}
